module.exports = __webpack_public_path__ + "img/app.10b88a1f.png";